
import { useState, useEffect } from "react";
import { toast } from "sonner";

interface InventoryItem {
  id: number;
  name: string;
  stock: number;
  minimum: number;
  status: string;
}

export const useInventoryCheck = () => {
  const [filteredItems, setFilteredItems] = useState<InventoryItem[]>([]);
  const [isAiSearching, setIsAiSearching] = useState(false);
  
  // Mock inventory data
  const inventoryItems = [
    { id: 1, name: "Product A", stock: 145, minimum: 50, status: "op_voorraad" },
    { id: 2, name: "Product B", stock: 32, minimum: 30, status: "bijna_op" },
    { id: 3, name: "Product C", stock: 78, minimum: 25, status: "op_voorraad" },
    { id: 4, name: "Product D", stock: 12, minimum: 40, status: "tekort" },
    { id: 5, name: "Product E", stock: 205, minimum: 100, status: "op_voorraad" },
    { id: 6, name: "Super Premium Verf", stock: 45, minimum: 20, status: "op_voorraad" },
    { id: 7, name: "Sigma Muurverf Wit", stock: 23, minimum: 30, status: "bijna_op" },
    { id: 8, name: "Betonverf Grijs", stock: 8, minimum: 15, status: "tekort" },
    { id: 9, name: "Histor Lakverf Hoogglans", stock: 52, minimum: 25, status: "op_voorraad" },
    { id: 10, name: "RAL-9010 Coating", stock: 18, minimum: 20, status: "bijna_op" },
  ];

  // Mock inventory last updated time
  const inventoryLastUpdated = new Date();
  const formattedDate = inventoryLastUpdated.toLocaleDateString('nl-NL', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
  const formattedTime = inventoryLastUpdated.toLocaleTimeString('nl-NL', {
    hour: '2-digit',
    minute: '2-digit'
  });

  useEffect(() => {
    // Initialize with all items
    setFilteredItems(inventoryItems);
  }, []);

  const handleSearch = (searchTerm: string) => {
    if (searchTerm.length > 0) {
      // Filter items based on search term
      const filtered = inventoryItems.filter(item => 
        item.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredItems(filtered);
    } else {
      setFilteredItems(inventoryItems);
    }
  };
  
  const handleAiSearch = (searchTerm: string) => {
    if (!searchTerm.trim()) {
      toast.error("Voer een zoekterm in voor AI-zoeken");
      return;
    }
    
    setIsAiSearching(true);
    // Simulate AI processing
    setTimeout(() => {
      // Mock AI suggested items based on search query intent
      let aiResult = [];
      
      if (searchTerm.toLowerCase().includes("verf") || searchTerm.toLowerCase().includes("coating")) {
        aiResult = inventoryItems.filter(item => 
          item.name.toLowerCase().includes("verf") || 
          item.name.toLowerCase().includes("coating") || 
          item.name.toLowerCase().includes("sigma")
        );
      } else if (searchTerm.toLowerCase().includes("tekort") || searchTerm.toLowerCase().includes("bijna op")) {
        aiResult = inventoryItems.filter(item => item.status === "tekort" || item.status === "bijna_op");
      } else {
        // Default to basic search if no specific intent detected
        aiResult = inventoryItems.filter(item => 
          item.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
      }
      
      setFilteredItems(aiResult);
      setIsAiSearching(false);
      
      toast.success(`AI heeft ${aiResult.length} product(en) gevonden op basis van uw zoekopdracht`);
    }, 1500);
  };

  return {
    filteredItems,
    isAiSearching,
    formattedDate,
    formattedTime,
    handleSearch,
    handleAiSearch
  };
};
